import React, { useState, useEffect, useRef } from 'react';
import './AppHeader.scss';
import { Header, Icon, Popup, VerticalMenu,Button } from '@scuf/common';
import { UserManager } from '@forge/sso-client';
import useWindowSize from '../../utils/useWindowSize';
import { BREAKPOINTS, IMAGE_NOT_FOUND, REJECT_TOAST_MSG, DASHBOARD_TABS, USER_ROLE, RouteConstants } from '../../constants/constants';
import { useSelector } from 'react-redux';
import { getUserInfo, setActiveDashboardTab } from '../../slices/userProfileSlice';
import forgeLogo from '../../images/HWF_Logo.png';
import FeedbackCard from '../FeedbackCard/FeedbackCard';
import { toast, Zoom } from 'react-toastify';
import { Snackbar } from '../Snackbar/Snackbar';
import { CSSTransition } from 'react-transition-group';
import { getOnBoardingAPIData, getOnBoardingAPIStatus, setCurrentRole,setGuideTour } from '../../slices/onBoardingSlice';
import { clearAllFilters, setPaginationCurrentPage } from '../../slices/allOpportunitySlice';
import { Flag } from './Flag';
import { Select } from '@scuf/common';
import TourIcon from 'src/images/presentation-svgrepo-com.svg';
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { IRoleSwitchModel } from '../../../src/models/IAllOpportunitiesModel';
import { getCurrentRole,getGuideTour } from 'src/slices/onBoardingSlice';
import { setOverviewViewType } from 'src/slices/overviewSlice';
import { isAks } from 'src/utils/properties/UrlsAndEnvProperties';
import RequestNewAlert from './RequestNewAlert';
import { tagEvent, TAG_EVENT_CONST, setUserRole } from 'src/utils/analytics/analytics.service.util';
import { adminUser } from 'src/utils/roleAccessUtils';
import { ActiveUserList } from '../ActiveUserList/ActiveUserList';
import FontIcon from '../FontIcon/FontIcon';
import { getMessage } from '../../message/utils';
import HeaderDropdown from './HeaderDropdown';
import CallIcon from 'src/images/call.svg'
import { useTour } from '@reactour/tour'
import {
  getAllOpportunitiesSelector,
  getCurentOpportunitiesSelector
} from '../../slices/allOpportunitySlice';
import {
  getLandOpportunity,
  
} from 'src/slices/landlinePageSlice';
import { getFilterListAPIData,  } from 'src/slices/overviewSlice';
// import { getOnBoardingAPIData, getOnBoardingAPIStatus } from '../../slices/onBoardingSlice';

const AppHeader = (props: any) => {
  // const history = useLocation();
  let location = useLocation();

  const { width } = useWindowSize();
  const smallDevice = width && width <= BREAKPOINTS.XS ? true : false;
  const userManager = UserManager.getInstance();
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showProfileMenuPopup, setShowProfileMenuPopup] = useState(false);

  const [showFeedbackPopup, setFeedbackPopup] = useState(false);
  const [userRoles, setUserRoles] = useState<IRoleSwitchModel[]>([]);
  const { eid, name, user_img_url } = useSelector(getUserInfo);

  const [isManageProfileDiabled, setManageProfileState] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsOpen } = useTour()

  const currentRole = useSelector(getCurrentRole);
  const guideTour = useSelector(getGuideTour);
  const guideTourValue = sessionStorage.getItem("guideTour");

  const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);
  const userOnboardData = useSelector(getOnBoardingAPIData);
  let profileref: any = useRef();
  let feedbackref: any = useRef();
  let pendingRef: any = useRef();
  const headerTitle: string = getMessage('app.header.title');
  const manageProfile: string = getMessage('app.header.menu.profile');
  const controlCenter: string = getMessage('app.header.menu.controlcenter');
  const help: string = getMessage('app.header.menu.help');
  const signOut: string = getMessage('app.header.menu.signout');
  const { setSteps, setCurrentStep } = useTour();

  const { status } = useSelector(getAllOpportunitiesSelector);
  const currentOpportunity = useSelector(getCurentOpportunitiesSelector);
  const { loading, opportunity_detail } = useSelector(getLandOpportunity);
  const filterListAPIData:any= useSelector(getFilterListAPIData);


  useEffect(() => {
   
    let currentguidetourValue:any=sessionStorage.getItem("guideTour");
    const guideTourValueLocal:any = JSON.parse(currentguidetourValue);
    //  setIsOpen(false)
      setCurrentStep(0);
      // console.log("status",status);

    if(location.pathname === "/anomalies/list" &&status=="finished"){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
          selector:'.prompt',
          content: <div>Search Anomaly Alert Module here. </div>,
          stepInteraction: false 
          },
          {
            selector: '.btn_filters',
            content: <div>Organize your search by applying the filters. </div>,
            stepInteraction: false 
          },
          {
            selector: '.export-icon-btn',
            content: <div>Export/Download anomalies from here. </div>,
            stepInteraction: false 
          },

          
          {
            selector: '.allopportunity__result-data',
            content: <div>These are list of the identified anomalies. Click on view details to take an action on the anomaly</div>
          }

        ]);
      }
      if(location.pathname === "/anomalies/list" &&status=="finished"&& (currentRole ==='insight.org_user' ) ){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector:'.prompt',
            content: <div>Search Anomaly Alert Module here. </div>,
            stepInteraction: false 
            },
          {
            selector: '.btn_filters',
            content: <div>Organize your search by applying the filters. </div>,
            stepInteraction: false 
          },
          {
            selector: '.toggle-btn',
            content: <div>Toggle on to display all anomalies in your List </div>,
            stepInteraction: false 

          },
          {
            selector: '.export-icon-btn',
            content: <div>Export/Download anomalies from here. </div>,
            stepInteraction: false 
          },
          {
            selector: '.allopportunity__result-data',
            content: <div>These are list of the identified anomalies. Click on view details to take an action on the anomaly</div>
          }

        ]);
      }

      else if(location.pathname === "/anomalies/sample" &&  (currentRole ==='insight.domain_focal' ) ){
        setSteps([
          {
            selector: '.allopportunity__result-data',
            content: <div>View sampled anomalies here</div>,
            stepInteraction: false 
          },
        ]);
      }

      else if(location.pathname === "/anomalies/orphan" &&  (currentRole ==='insight.domain_focal' )){
        setSteps([
          {
            selector: '.allopportunity__result-data',
            content: <div>Here we can get <b>Unassigned</b> anomalies </div>,
            stepInteraction: false 
          },
        ]);
      }

      else if(location.pathname.includes('/detail') && currentRole==='insight.owner' && currentOpportunity.status=="finished" ){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector: '.content',
            content: <div>This section gives high level details and current status of the anomaly.</div>
          },
          {
            selector: '.details',
            content: <div>This section gives the details about the anomaly </div>,
            stepInteraction: false 
          },
          {
            selector: '.audit',
            content: <div>This section captures the historical activities happened on the anomaly. </div>,
            stepInteraction: false 
          },
          {
            selector: '.button-footer-right',
            content: <div>

              <div style={{
                border: '1px solid black',
                padding: '10px',
                margin: '10px',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontFamily: 'Arial, sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                lineHeight: '1.5',
                borderRadius: '5px'
              }}>
                <p><strong>Get More Context:</strong> Click this button to share the anomaly with other person in the organization to get more context .</p>
                <p><strong>Comment:</strong> Click this button to add comment and notes about the anomaly</p>
                {/* <p><strong>Action Required:</strong> Click this button to mark action required.</p>
                <p><strong>No Action Required:</strong> Click this button to mark no action required ..</p> */}
                <p><strong>Review:</strong> Choose this option to review this anomaly,if its not reviewed</p>
                <p><strong>Note:</strong>Get More Context and Review option will not appear once review is completed </p>
        </div>





          </div>,
            stepInteraction: false 
          }
        ]);
      }

      else if (location.pathname === "/landing_page" && currentRole==='insight.owner'&& loading==false&& status=="finished" ) {
        
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
  setSteps([
    {
      selector: '.role-switch',
      content: <div>Click here to select the role.</div>,
      stepInteraction: false 
    },
    {
      selector: '.contact-support',
      content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
      stepInteraction: false 
    },
    {
      selector: '.fi-header__items__user-profile',
      content: <div>Click here to manage user profile section</div>,
      stepInteraction: false 
    },
    
    {
      selector: '.Anomalies',
      content: <div>Click here to explore all identified anomalies.</div>,
     
    },
  
  
    {
      selector: '.large-card-list',
      content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
      stepInteraction: false 

     
    }
  ]);
}else{
  setSteps([
    
    {
      selector: '.contact-support',
      content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
      stepInteraction: false 
    },
    {
      selector: '.fi-header__items__user-profile',
      content: <div>Click here to manage user profile section</div>,
      stepInteraction: false 
    },
    
    {
      selector: '.Anomalies',
      content: <div>Click here to explore all identified anomalies.</div>,
     
    },
  
  
    {
      selector: '.large-card-list',
      content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
      stepInteraction: false 

     
    }
  ]);
}

       
      } 
      
      else if (location.pathname === "/landing_page" && currentRole==='insight.owner' ) {

        if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){   
          setSteps([
          {
            selector: '.role-switch',
            content: <div>Click here to select the role.</div>,
            stepInteraction: false 
          },
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
           
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Anomalies',
            content: <div>Click here to explore all identified anomalies.</div>,
           
          },
        
        
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
            stepInteraction: false 

           
          }
        ]);}
        else{
          setSteps([
          
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
             
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Anomalies',
              content: <div>Click here to explore all identified anomalies.</div>,
             
            },
          
          
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
              stepInteraction: false 
  
             
            }
          ]);
        }
  
      } 
      else if (location.pathname === "/landing_page" && currentRole==='insight.org_user'&& loading==false
        // && status=="finished"
       ) {
        
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)

        if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
          setSteps([
            {
              selector: '.role-switch',
              content: <div>Click here to select the role.</div>,
              stepInteraction: false 
            },
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Overview',
              content: <div> Click  Analyse  button to Analyse the anomalies trends</div>,
             
            },
          
            {
              selector: '.Anomalies',
              content: <div>Click here to explore all identified anomalies.</div>,
             
            },
          
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
              stepInteraction: false 
  
             
            }
          ]);
          
        }else{
          setSteps([
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Overview',
              content: <div> Click  Analyse  button to Analyse the anomalies trends</div>,
             
            },
          
            {
              selector: '.Anomalies',
              content: <div>Click here to explore all identified anomalies.</div>,
             
            },
          
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
              stepInteraction: false 
  
             
            }
          ]);
        }
       
      } 
      else if(location.pathname.includes('/detail') && currentRole==='insight.org_user' && currentOpportunity.status=="finished" ){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector: '.content',
            content: <div>This section gives high level details and current status of the anomaly. </div>
          },
          {
            selector: '.details',
            content: <div>This section gives the details about the anomaly </div>,
            stepInteraction: false 
          },
          {
            selector: '.audit',
            content: <div>This section captures the historical activities happened on the anomaly. </div>,
            stepInteraction: false 
          },
          {
            selector: '.button-footer-right',
            content: <div>
            <div style={{
              border: '1px solid black',
              padding: '10px',
              margin: '10px',
              backgroundColor: '#f0f0f0',
              color: '#333',
              fontFamily: 'Arial, sans-serif',
              fontSize: '16px',
              textAlign: 'left',
              lineHeight: '1.5',
              borderRadius: '5px'
            }}>
              <p><strong>Get More Context:</strong> Click this button to share the anomaly with other person in the organization to get more context .</p>
              <p><strong>Comment:</strong> Click this button to add comment and notes about the anomaly</p>
              <p><strong>Action Required:</strong> Click this button to mark action required.</p>
              <p><strong>No Action Required:</strong> Click this button to mark no action required ..</p>
              <p><strong>Review Task:</strong> Here we can track the action completion status</p>
              <p><strong>Complete Task:</strong> Click this button to close the action(s) on this anomaly</p>
              <p><strong>Note:</strong> Action Required and No Action Required option will appear after review,Review task option will appear after an action is assigned to action owner and Complete task option will appear once action owner completes the assigned action(s)</p>
              </div></div>,
            stepInteraction: false 
          }
        ]);
        
      }
      else if(location.pathname === "/landing_page" && (currentRole==='insight.power_user')){

        if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
          setSteps([
            {
              selector: '.role-switch',
              content: <div>Click here to select the role.</div>,
              stepInteraction: false 
            },
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Overview',
              content: <div> Click Analyse button to Analyse the anomalies trends</div>,
            },
        
            {
              selector: '.Anomalies',
              content: <div>Click here to explore all identified anomalies.</div>,
            },
            //   {
            //   selector: '.Sample',
            //   content: <div>Click here to explore all sampled anomalies.</div>,
            // },
             
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
              stepInteraction: false 
  
            },
        
         
          ]);
        }
        else{
          setSteps([
         
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Overview',
              content: <div> Click Analyse button to Analyse the anomalies trends</div>,
            },
        
            {
              selector: '.Anomalies',
              content: <div>Click here to explore all identified anomalies.</div>,
            },
            //   {
            //   selector: '.Sample',
            //   content: <div>Click here to explore all sampled anomalies.</div>,
            // },
             
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
              stepInteraction: false 
  
            },
        
         
          ]);
        }
      
      }

      else if(location.pathname === "/anomalies/sample" &&  (currentRole ==='insight.power_user' ) ){
        setSteps([
          {
            selector: '.allopportunity__result-data',
            content: <div>View sampled anomalies here</div>,
            stepInteraction: false 
          },
        ]);
      }

  

      else if(location.pathname.includes('/detail') && currentRole==='insight.power_user' && currentOpportunity.status=="finished" ){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector: '.content',
            content: <div>This section gives high level details and current status of the anomaly. </div>
          },
          {
            selector: '.details',
            content: <div>This section gives the details about the anomaly </div>,
            stepInteraction: false 
          },
          {
            selector: '.audit',
            content: <div>This section catpures the user activity on the anomaly </div>,
            stepInteraction: false 
          },
          {
            selector: '.button-footer-right',
            content: <div>
 
    <div style={{
      border: '1px solid black',
      padding: '10px',
      margin: '10px',
      backgroundColor: '#f0f0f0',
      color: '#333',
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      textAlign: 'left',
      lineHeight: '1.5',
      borderRadius: '5px'
    }}>
      <p><strong>Share:</strong> If you choose this option, you can share this anomaly with other person in the organization .</p>
      <p><strong>Audit Reject:</strong> Click audit reject button to reject the anomaly.</p>
      <p><strong>Audit Accept:</strong> Click the audit accept button to accept the anomaly, confirming that the work meets all necessary criteria</p>
      <p><strong>Comment:</strong> Click this button to add comment and notes about the anomaly</p>
      <p><strong>Review Task:</strong> This option allows you to review the actions by action owners.</p>
      <p><strong>Note:</strong> Audit Reject and Audit Accept option appears once initial review is completed by reviewer. Review task option appears when an action is assigned to action owner by orgowner</p>
    </div>
 

              
              </div>,
            stepInteraction: false 
          }
        ]);
        
      }
      else if(location.pathname.includes('/detail') && currentRole==='insight.domain_focal' && currentOpportunity.status=="finished" ){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector: '.content',
            content: <div>This section gives high level details and current status of the anomaly. </div>
          },
          {
            selector: '.details',
            content: <div>This section gives the details about the anomaly </div>,
            stepInteraction: false 
          },
          {
            selector: '.audit',
            content: <div>This section catpures the user activity on the anomaly </div>,
            stepInteraction: false 
          },
          {
            selector: '.button-footer-right',
            content: <div>
              <div style={{
                border: '1px solid black',
                padding: '10px',
                margin: '10px',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontFamily: 'Arial, sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                lineHeight: '1.5',
                borderRadius: '5px'
              }}>
                <p><strong>Share:</strong> If you choose this option, you can share this anomaly with other person in the organization .</p>
                <p><strong>Business Reject:</strong> Click audit reject button to reject the anomaly.</p>
                <p><strong>Business Accept:</strong> This choice signals your approval of the anomaly. By selecting "Business Accept" you confirm that the work meets the necessary criteria.</p>
                <p><strong>Comment:</strong> Click this button to add comment and notes about the anomaly</p>
                <p><strong>Note:</strong> Business Reject and Business Accept option appears once initial review is completed by reviewer. </p>
              </div>
            </div>,
            stepInteraction: false 
          }
        ]);
        
      }
      else if(location.pathname.includes('/detail') && currentRole==='insight.functional_leadership' && currentOpportunity.status=="finished" ){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector: '.content',
            content: <div>This section gives high level details and current status of the anomaly. </div>,
          },
          {
            selector: '.details',
            content: <div>This section gives the details about the anomaly </div>,
            stepInteraction: false 
            
          },
          {
            selector: '.audit',
            content: <div>This section catpures the user activity on the anomaly </div>,
            stepInteraction: false 
          },
          {
            selector: '.button-footer-right',
            content: <div>
                <div style={{
      border: '1px solid black',
      padding: '10px',
      margin: '10px',
      backgroundColor: '#f0f0f0',
      color: '#333',
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      textAlign: 'left',
      lineHeight: '1.5',
      borderRadius: '5px'
    }}>
   <p><strong>Comment:</strong> Click this button to add comment and notes about the anomaly</p>
    </div>  
            </div>,
            stepInteraction: false 
          }
        ]);
        
      }

      else if(location.pathname.includes ("/context") && currentRole==='model.labeler'){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          { selector: '.Model_Name',
            content: <div>This is the model name.</div>
         
            
          }, 
          {
            selector: '.Model_Stage',
            content: <div>This is the current stage of the model.</div>
         
          },
          {
            selector: '.Model_Stage_Name',
            content: <div>This is the model stage name.</div>
         
          },
          
          {
            selector: '.Action',
            content: <div>Click on Training Required Button to take Necessary Actions.</div>
         
          }
      ]);
      }

      else if(location.pathname === "/landing_page" && ( currentRole==='model.labeler')){

        if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
          setSteps([
            {
              selector: '.role-switch',
              content: <div>Click here to select the role.</div>,
              stepInteraction: false 
            },
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Models ',
              content: <div>Click here to explore all identified <b>Models</b>.</div>,
              },
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent Models assigned to you for review.</div>,
              stepInteraction: false 
            },
        
         
          ]);
        }
        else{
          setSteps([
                      {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Models ',
              content: <div>Click here to explore all identified <b>Models</b>.</div>,
              },
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent Models assigned to you for review.</div>,
              stepInteraction: false 
            },
        
         
          ]);
        }
      
      }

      else if(location.pathname === "/anomalies/context" && currentRole==='model.power_user' ){
        // (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          { selector: '.Model_Name',
            content: <div>This is the model name.</div>
         
            
          }, 
          {
            selector: '.Model_Stage',
            content: <div>This is the current stage of the model.</div>
         
          },
          {
            selector: '.Model_Stage_Name',
            content: <div>This is the model stage name.</div>
         
          },
          {
            selector: '.Action',
            content: <div>Click on <b>Training Required</b> Button to take Necessary Actions.</div>,
            stepInteraction: false
        
          },
          {
            selector: '.tooltip-context-conatiner',
            content: <div>Here we can view the <b>user Guide </b>.</div>,
            stepInteraction: false
          },
          {
            selector: '.button-content',
            content: <div>Click here to navigated to <b>Edit or Create model screen</b> .</div>,
            stepInteraction: false

         
          },
      ]);
      }

      else if(location.pathname === "/anomalies/context/edit" && currentRole==='model.power_user' ){
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector: '.ag-theme-alpine',
            content: <div>Here we can view the models with their current stages and we can click on <b>Edit</b> button to edit model configurations .</div>,
            stepInteraction: false

          },
          {
            selector: '.button-content',
            content: <div>Click on <b>Add New Model</b> to create a new model.</div>,
            stepInteraction: false
        
          },
      ]);
      }
      

      else if(location.pathname === "/landing_page" &&  (currentRole ==='model.power_user')){

        if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
          setSteps([
            {
              selector: '.role-switch',
              content: <div>Click here to select the role.</div>,
              stepInteraction: false 
            },
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Models ',
              content: <div>Click here to explore all identified Models.</div>,
              stepInteraction: false 
  
              
            },
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent Models assigned to you for review.</div>,
              stepInteraction: false
            },       
          ]);
        }
        else{
          setSteps([
         
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
              stepInteraction: false 
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Models ',
              content: <div>Click here to explore all identified Models.</div>,
              stepInteraction: false 
  
              
            },
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent Models assigned to you for review.</div>,
              stepInteraction: false
            },       
          ]);
        }
      
      }


      else if (
  location.pathname.startsWith("/anomalies/context/edit") &&
  currentRole === "model.power_user"
) {
  // Extract the anomaly ID from the URL
  const anomalyId = location.pathname.split("/").pop();
  // Conditionally open the tour
  guideTourValueLocal ? setIsOpen(true) : setIsOpen(false);
  const sidebarItems = Array.from(document.querySelectorAll('.sidebar .tab1.labeling'));
  // Dynamically create steps for sidebar items
  const sidebarSteps = sidebarItems.map((item, index) => {
    const labelText = item.querySelector('.sidebar-label')?.textContent.trim();

    if (!labelText) return null; // Skip if no label text is found 
    let customText = '';
    switch (labelText) {
      case '0-Setup':
        customText = <div>Here we can update model name</div>;
        break;
      // Skip '1-Prep' and '4-Delivery'
      case '1-Prep': 
      case '4-Delivery': 
      return null; // Skip these steps
 
      case '2-Labeling':
        customText = <div>Here we can configure the <b>questions</b> and <b>tableau link</b> for the model in labeling stage</div>;
        break;
      case '3-Tuning':
        customText = <div>Here we can configure the <b>questions</b> and <b>tableau link</b> for the model in Tuning stage</div>;
        break;
      default:
        customText = `This is the <b>${labelText}</b> step for anomaly <b>${anomalyId}</b>.`;
    }
 
    return {
      selector: `.sidebar .tab1.labeling:nth-of-type(${index + 1})`,
      content: <div>{customText}</div>,
      stepInteraction: false, // Allow interaction with the step
    };
  }).filter(Boolean); // Filter out any null steps for '1-Prep' and '4-Delivery'
  const setActiveStageItem = document.querySelector('.sidebar .tab1:last-child');
  if (setActiveStageItem) {
    sidebarSteps.push({
      selector: '.sidebar .tab1:last-child', // Last tab for "Set Active Stage"
      content: (
<div>
          Here we can set the <b>Stage</b> of the Model 
</div>
      ),
      stepInteraction: false, // Allow interaction
    });
  }
  // Set the dynamic steps (without Cancel and Update button steps)
  setSteps([
    {
      selector: `.button-content`,
      content: (
<div>
Click on <b>Add New Model</b> to create a new model.
</div>
      ),
      stepInteraction: false,
    },
    ...sidebarSteps, // Add sidebar steps
  ]);
}
      


      else if (location.pathname.includes ("context")&&filterListAPIData.status=="finished") {
        console.log("&& filterListAPIData.length>0 ",filterListAPIData.status );
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
        setSteps([
          {
            selector: '.edit-context-list-container',
            content: <div>click on to go back.</div>
            
          }
        ])
      }

      

      else if (location.pathname === "/anomalies/overview"&&filterListAPIData.status=="finished") {
        console.log("&& filterListAPIData.length>0 ",filterListAPIData.status );
        (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
          setSteps([
            {
              selector: '.content-item',
              content: <div>Use graphical representations to analyse anomalies for clear insights.</div>
            },
              {
                selector: '.slider_container',
                content: <div>Click the indicators to view different graphical visualization</div>,
                stepInteraction: false 
              },
              {
                selector: '.header__actions',
                content: <div>Choose appropriate filter to view subset of data.</div>,
                stepInteraction: false 
              },
         ]);
        }

        else if(location.pathname === "/landing_page" && (currentRole==='insight.domain_focal' )){
          if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
            setSteps([
              {
                selector: '.role-switch',
                content: <div>Click here to select the role.</div>,
                stepInteraction: false 
              },
              {
                selector: '.contact-support',
                content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
             
              },
              {
                selector: '.fi-header__items__user-profile',
                content: <div>Click here to manage user profile section</div>,
                stepInteraction: false 
              },
              
              {
                selector: '.Overview',
                content: <div> Click Analyse button to Analyse the anomalies trends</div>,
              },
          
              {
                selector: '.Anomalies',
                content: <div>Click here to explore all identified anomalies.</div>,
              },
              {
                selector: '.Unassigned',
                content: <div>Click here to explore all unassigned anomalies.</div>,
              },
               
              //   {
              //   selector: '.Sample',
              //   content: <div>Click here to explore all sampled anomalies.</div>,
              // },
               
              {
                selector: '.large-card-list',
                content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
                stepInteraction: false 
  
              },
          
           
            ]);
          }
          else{
            setSteps([
          
              {
                selector: '.contact-support',
                content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
             
              },
              {
                selector: '.fi-header__items__user-profile',
                content: <div>Click here to manage user profile section</div>,
                stepInteraction: false 
              },
              
              {
                selector: '.Overview',
                content: <div> Click Analyse button to Analyse the anomalies trends</div>,
              },
          
              {
                selector: '.Anomalies',
                content: <div>Click here to explore all identified anomalies.</div>,
              },
              {
                selector: '.Unassigned',
                content: <div>Click here to explore all unassigned anomalies.</div>,
              },
               
              //   {
              //   selector: '.Sample',
              //   content: <div>Click here to explore all sampled anomalies.</div>,
              // },
               
              {
                selector: '.large-card-list',
                content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
                stepInteraction: false 
  
              },
          
           
            ]);

          }
        
        }

        else if(location.pathname === "/landing_page" &&  (currentRole ==='model.functional_leadership')){
          if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){ 
             setSteps([
            {
              selector: '.role-switch',
              content: <div>Click here to select the role.</div>,
              stepInteraction: false 
            },
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
           
           
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Model',
              content: <div>In this section we can review model results</div>,
              stepInteraction: false 

            },
            {
              selector: '.KPI',
              content: <div>In this section can get training reports(score board,training history etc).</div>,
              stepInteraction: false 

            },

            // {
            //   selector: '.CAMS',
            //   content: <div>AI Model.</div>,
            //   stepInteraction: false 

            // }
          ]);}
          else{
            setSteps([
            
              {
                selector: '.contact-support',
                content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
             
             
              },
              {
                selector: '.fi-header__items__user-profile',
                content: <div>Click here to manage user profile section</div>,
                stepInteraction: false 
              },
              
              {
                selector: '.Model',
                content: <div>In this section we can review model results</div>,
                stepInteraction: false 
  
              },
              {
                selector: '.KPI',
                content: <div>In this section can get training reports(score board,training history etc).</div>,
                stepInteraction: false 
  
              },
  
              // {
              //   selector: '.CAMS',
              //   content: <div>AI Model.</div>,
              //   stepInteraction: false 
  
              // }
            ]);
          }
        
        }

        else if(location.pathname === "/landing_page" && (currentRole==='insight.org_user' || currentRole==='insight.functional_leadership') ){
        
        if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
          setSteps([
            {
              selector: '.role-switch',
              content: <div>Click here to select the role.</div>,
              stepInteraction: false 
            },
            {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
           
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Overview',
              content: <div> Click Analyse button to Analyse the anomalies trends</div>,
            },
        
            {
              selector: '.Anomalies',
              content: <div>Click here to explore all identified anomalies.</div>,
            },
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
              stepInteraction: false 

            },
        
         
          ]);
        }
        else{
          setSteps([
                       {
              selector: '.contact-support',
              content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
           
            },
            {
              selector: '.fi-header__items__user-profile',
              content: <div>Click here to manage user profile section</div>,
              stepInteraction: false 
            },
            
            {
              selector: '.Overview',
              content: <div> Click Analyse button to Analyse the anomalies trends</div>,
            },
        
            {
              selector: '.Anomalies',
              content: <div>Click here to explore all identified anomalies.</div>,
            },
            {
              selector: '.large-card-list',
              content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
              stepInteraction: false 

            },
        
         
          ]);
        }
       
        }

        else if(location.pathname === "/landing_page" && (currentRole==='insight.viewer') ){
          if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
            setSteps([
              {
                selector: '.role-switch',
                content: <div>Click here to select the role.</div>,
                stepInteraction: false 
              },
              {
                selector: '.contact-support',
                content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
             
              },
              {
                selector: '.fi-header__items__user-profile',
                content: <div>Click here to manage user profile section</div>,
                stepInteraction: false 
              },
              
              {
                selector: '.Anomalies',
                content: <div>Click here to explore all identified anomalies.</div>,
              },
              {
                selector: '.large-card-list',
                content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
                stepInteraction: false 
  
              },
          
           
            ]);
          }
          else{
            setSteps([
          
              {
                selector: '.contact-support',
                content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
             
              },
              {
                selector: '.fi-header__items__user-profile',
                content: <div>Click here to manage user profile section</div>,
                stepInteraction: false 
              },
              
              {
                selector: '.Anomalies',
                content: <div>Click here to explore all identified anomalies.</div>,
              },
              {
                selector: '.large-card-list',
                content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
                stepInteraction: false 
  
              },
          
           
            ]);
          }
         
        }

        else if(location.pathname.includes('/detail') && currentRole==='insight.viewer' && currentOpportunity.status=="finished" ){
          (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
          setSteps([
            {
              selector: '.content',
              content: <div>This section gives high level details and current status of the anomaly. </div>
            },
            {
              selector: '.details',
              content: <div>This section gives the details about the anomaly </div>,
              stepInteraction: false 
            },
            {
              selector: '.audit',
              content: <div>This section catpures the user activity on the anomaly </div>,
              stepInteraction: false 
            },
            {
              selector: '.button-footer-right',
              content: <div>
              <div style={{
      border: '1px solid black',
      padding: '10px',
      margin: '10px',
      backgroundColor: '#f0f0f0',
      color: '#333',
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      textAlign: 'left',
      lineHeight: '1.5',
      borderRadius: '5px'
    }}>
      <p><strong>Get More Context:</strong> Click this button to share the anomaly with other person in the organization to get more context .</p>
        <p><strong>Comment:</strong> Click this button to add comment and notes about the anomaly</p>
    </div>
             
            </div>,
              stepInteraction: false 
            }
          ]);
        }


        else if((location.pathname === "/anomalies/model_review"||location.pathname === "anomalies/metric_dashboard"||location.pathname ==="/anomalies/cams_gpt" ) &&  (currentRole ==='model.functional_leadership')){
          setSteps([
            {
              selector: '.model_review',
              content: <div>Click here to explore all identified Models.</div>,
              stepInteraction: false

            },
            {
              selector: '.metric_dashboard',
              content: <div>Review model training reports.</div>,
              stepInteraction: false

            },
    
            // {
            //   selector: '.cams_gpt',
            //   content: <div>AI Model.</div>,
            //   stepInteraction: false

            // }
      
      
          ]);
        }
        
      else{
        setIsOpen(false)
      }

  }, [location.pathname, setCurrentStep, setSteps,guideTour,guideTourValue,status,currentOpportunity.status,loading,filterListAPIData.status]);


  useEffect(()=>{
    console.log("guideTour",guideTour)
    if(guideTour===false)
    {
      setIsOpen(false)
      dispatch(setGuideTour(false))
    }
  },[guideTour])


  useEffect(() => {
    setCurrentStep(0);
    if (location.pathname === "/landing_page" && currentRole==='insight.owner') {

      if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
        setSteps([
          {
            selector: '.role-switch',
            content: <div>Click here to select the role.</div>,
            stepInteraction: false 
          },
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Anomalies',
            content: <div>Click here to explore all identified anomalies.</div>,
           
          },
        
        
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
            stepInteraction: false 
  
           
          }
        ]);
      }
      else{
        setSteps([
         
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Anomalies',
            content: <div>Click here to explore all identified anomalies.</div>,
           
          },
        
        
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
            stepInteraction: false 
  
           
          }
        ]);
      }
   
    } else if(location.pathname === "/landing_page" && (currentRole==='insight.org_user' || currentRole==='insight.functional_leadership') ){
    
    if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
      setSteps([
        {
          selector: '.role-switch',
          content: <div>Click here to select the role.</div>,
          stepInteraction: false 
        },
        {
          selector: '.contact-support',
          content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
          stepInteraction: false 
        },
        {
          selector: '.fi-header__items__user-profile',
          content: <div>Click here to manage user profile section</div>,
          stepInteraction: false 
        },
        
        {
          selector: '.Overview',
          content: <div> Click  Analyse  button to Analyse the anomalies trends</div>,
        },
    
        {
          selector: '.Anomalies',
          content: <div>Click here to explore all identified anomalies.</div>,
        },
        {
          selector: '.large-card-list',
          content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
          stepInteraction: false 

        },
    
     
      ]);
    }
    else{
      setSteps([
       
        {
          selector: '.contact-support',
          content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
          stepInteraction: false 
        },
        {
          selector: '.fi-header__items__user-profile',
          content: <div>Click here to manage user profile section</div>,
          stepInteraction: false 
        },
        
        {
          selector: '.Overview',
          content: <div> Click Analyse button to Analyse the anomalies trends</div>,
        },
    
        {
          selector: '.Anomalies',
          content: <div>Click here to explore all identified anomalies.</div>,
        },
        {
          selector: '.large-card-list',
          content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
          stepInteraction: false 

        },
    
     
      ]);
    }
    
    }
    else if(location.pathname === "/landing_page" && (currentRole==='insight.power_user')){

      if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
        setSteps([
          {
            selector: '.role-switch',
            content: <div>Click here to select the role.</div>,
            stepInteraction: false 
          },
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Overview',
            content: <div> Click Analyse button to Analyse the anomalies trends</div>,
          },
      
          {
            selector: '.Anomalies',
            content: <div>Click here to explore all identified anomalies.</div>,
          },
          //   {
          //   selector: '.Sample',
          //   content: <div>Click here to explore all sampled anomalies.</div>,
          // },
           
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
            stepInteraction: false 
  
          },
      
       
        ]);
      }
      else{
        setSteps([
        
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Overview',
            content: <div> Click Analyse button to Analyse the anomalies trends</div>,
          },
      
          {
            selector: '.Anomalies',
            content: <div>Click here to explore all identified anomalies.</div>,
          },
          //   {
          //   selector: '.Sample',
          //   content: <div>Click here to explore all sampled anomalies.</div>,
          // },
           
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
            stepInteraction: false 
  
          },
      
       
        ]);
      }
     
    }
    else if(location.pathname === "/landing_page" && (currentRole==='insight.domain_focal' )){
      if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
        setSteps([
          {
            selector: '.role-switch',
            content: <div>Click here to select the role.</div>,
            stepInteraction: false 
          },
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Overview',
            content: <div> Click  Analyse  button to Analyse the anomalies trends</div>,
          },
      
          {
            selector: '.Anomalies',
            content: <div>Click here to explore all identified anomalies.</div>,
          },
          {
            selector: '.Unassigned',
            content: <div>Click here to explore all unassigned anomalies.</div>,
          },
           
          //   {
          //   selector: '.Sample',
          //   content: <div>Click here to explore all sampled anomalies.</div>,
          // },
           
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
            stepInteraction: false 
  
          },
      
       
        ]);
      }
      else{
        setSteps([
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Overview',
            content: <div> Click  Analyse  button to Analyse the anomalies trends</div>,
          },
      
          {
            selector: '.Anomalies',
            content: <div>Click here to explore all identified anomalies.</div>,
          },
          {
            selector: '.Unassigned',
            content: <div>Click here to explore all unassigned anomalies.</div>,
          },
           
          //   {
          //   selector: '.Sample',
          //   content: <div>Click here to explore all sampled anomalies.</div>,
          // },
           
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent anomalies assigned to you for review.</div>,
            stepInteraction: false 
  
          },
      
       
        ]);
      }
     
    }
    // else if(location.pathname.includes('/detail') && currentRole==='model.labeler' && currentOpportunity.status=="finished" ){
    //   (guideTourValueLocal==true)?setIsOpen(true):setIsOpen(false)
    //   setSteps([
    //     {
    //       selector: '.content',
    //       content: <div>This section gives high level details and  current status of the anomaly. </div>
    //     },
    //   ])
      
    // }
    else if(location.pathname === "/landing_page" &&  (currentRole ==='model.functional_leadership')){
      if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
        setSteps([
          {
            selector: '.role-switch',
            content: <div>Click here to select the role.</div>,
            stepInteraction: false 
          },
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Model',
            content: <div>Review Model Results</div>,
          },
          {
            selector: '.KPI',
            content: <div>Review model training reports.</div>,
          },
  
          // {
          //   selector: '.CAMS',
          //   content: <div>AI Model.</div>,
          // }
        ]);
      }
      else{
        setSteps([
        
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Model',
            content: <div>Review Model Results</div>,
          },
          {
            selector: '.KPI',
            content: <div>Review model training reports.</div>,
          },
  
          // {
          //   selector: '.CAMS',
          //   content: <div>AI Model.</div>,
          // }
        ]);

      }
     
    }

    // else if(location.pathname === "/landing_page" &&  (currentRole ==='model.functional_leadership')){
    //   setSteps([
    //     {
    //       selector: '.role-switch',
    //       content: <div>Click here to select the role.</div>,
    //       stepInteraction: false 
    //     },
    //     {
    //       selector: '.contact-support',
    //       content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
    //       stepInteraction: false 
    //     },
    //     {
    //       selector: '.Model',
    //       content: <div>Click here to explore all identified Models.</div>,
    //     },
    //     {
    //       selector: '.KPI',
    //       content: <div>Click here to explore all identified Models.</div>,
    //     },

    //     {
    //       selector: '.CAMS',
    //       content: <div>Click here to explore all identified Models.</div>,
    //     }
    //   ]);
    // }
    else if((location.pathname === "/anomalies/model_review"||location.pathname === "anomalies/metric_dashboard"||location.pathname ==="/anomalies/cams_gpt" )  &&  (currentRole ==='model.functional_leadership')){
      setSteps([
        {
          selector: '.model_review',
          content: <div>Review Model Results.</div>,
        },
        {
          selector: '.metric_dashboard',
          content: <div>Review model training reports..</div>,
        },

        {
          selector: '.cams_gpt',
          content: <div>AI Models.</div>,
        }
  
      ]);
    }


    else if(location.pathname === "/landing_page" && currentRole==='model.labeler'){
      if(userOnboardData && userOnboardData.roles && userOnboardData.roles.length > 1){
        setSteps([
          {
            selector: '.role-switch',
            content: <div>Click here to select the role.</div>,
            stepInteraction: false 
          },
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Models ',
            content: <div>Click here to explore all identified Models.</div>,
            stepInteraction: false 
  
          },
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent Models assigned to you for review.</div>,
            stepInteraction: false 
          },
      
       
        ]);
      }
      else{
        setSteps([
        
          {
            selector: '.contact-support',
            content: <div>Click here to reach out to CAMS Support for any assistance or issues.</div>,
            stepInteraction: false 
          },
          {
            selector: '.fi-header__items__user-profile',
            content: <div>Click here to manage user profile section</div>,
            stepInteraction: false 
          },
          
          {
            selector: '.Models ',
            content: <div>Click here to explore all identified Models.</div>,
            stepInteraction: false 
  
          },
          {
            selector: '.large-card-list',
            content: <div>This section shows the most recent Models assigned to you for review.</div>,
            stepInteraction: false 
          },
      
       
        ]);
      }
     
    }

    
  



    console.log("currentRole",currentRole);
    // else {
    //   setSteps([
    //     {
    //       selector: '.role-switch',
    //       content: <div>Click here to select the role.</div>,
    //       // style: stepStyle
    //        
    //       // position:'bottom'
    //     }])
    // }

  }, [currentRole]);




  
  useEffect(() => {
    if (userOnboardAPIStatus === 'finished' && userOnboardData) {
      if (userOnboardData.user_onboard_status === 'on-boarded') {
        setManageProfileState(false);
      } else {
        setManageProfileState(true);
      }
      // userOnboardData && userOnboardData?.roles && dispatch(setCurrentRole(userOnboardData.roles[0]));
      // userOnboardData && userOnboardData?.roles && tagEvent(TAG_EVENT_CONST.role, { UserRole: userOnboardData.roles[0] });
      userOnboardData && userOnboardData?.roles && dispatch(setCurrentRole(sessionStorage.getItem("role") || userOnboardData.roles[0]));
      userOnboardData && userOnboardData?.roles && tagEvent(TAG_EVENT_CONST.role, { UserRole: sessionStorage.getItem("role") || userOnboardData.roles[0] });
      
      const roleSwitchOptions = [] as any;
      userOnboardData.roles?.map((value) => {
        if (value === USER_ROLE.ORG_USER) {
          roleSwitchOptions.push({ value: USER_ROLE.ORG_USER, text: "Org Owner" });
        } else if (value === USER_ROLE.DOMAIN_FOCAL) {
          roleSwitchOptions.push({ value: USER_ROLE.DOMAIN_FOCAL, text: "Domain Focal" });
        } else if (value === USER_ROLE.LEADERSHIP_USER) {
          roleSwitchOptions.push({ value: USER_ROLE.LEADERSHIP_USER, text: "Leadership" });
        } else if (value === USER_ROLE.POWER_USER) {
          roleSwitchOptions.push({ value: USER_ROLE.POWER_USER, text: "Power User" });
        } else if (value === USER_ROLE.REVIEWER) {
          roleSwitchOptions.push({ value: USER_ROLE.REVIEWER, text: "Reviewer" });
        } else if (value === USER_ROLE.VIEWER) {
          roleSwitchOptions.push({ value: USER_ROLE.VIEWER, text: "Viewer" });
        }
        else if (value === USER_ROLE.MODEL_POWER_USER) {
          roleSwitchOptions.push({ value: USER_ROLE.MODEL_POWER_USER, text: "Model Owner" });
        }
        else if (value === USER_ROLE.MODEL_LABELER) {
          roleSwitchOptions.push({ value: USER_ROLE.MODEL_LABELER, text: "Labeler" });
        }
        else if (value === USER_ROLE.MODEL_FUNCTIONAL_LEADERSHIP) {
          roleSwitchOptions.push({ value: USER_ROLE.MODEL_FUNCTIONAL_LEADERSHIP, text: "Functional Leadership" });
        }


        setUserRoles(roleSwitchOptions);
      })
    }
  }, [userOnboardAPIStatus]);

  const closeAllOtherPopup = () => {
    setFeedbackPopup(false);
    setShowProfilePopup(false);
  }


  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (profileref.current && !profileref.current.contains(event.target)) {
        setShowProfilePopup(false);
        setShowProfileMenuPopup(false);
      }
      if (feedbackref.current && !feedbackref.current.contains(event.target)) {
        setFeedbackPopup(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  });

  const handleClickInside = () => {
    setShowProfilePopup(true)
  };

  const handleClickInsideFeeback = (event: any) => {
    if (event.bubbles == false) {
      setFeedbackPopup(true)
    }
  };
  const closeFeedbackPopup = (showSnackbar?: boolean) => {
    if (showSnackbar) {
      toast(<Snackbar toastMessage={REJECT_TOAST_MSG} />, { position: 'bottom-right', className: 'fi-toast--snackbar', bodyClassName: 'fi-toast__body--snackbar', transition: Zoom, closeOnClick: true });
    }
    setFeedbackPopup(false);
  }

  const roleSwitchHandle = (value: string) => {
    dispatch(clearAllFilters([]));
    dispatch(setPaginationCurrentPage(1));
    dispatch(setOverviewViewType(""));
    // if (value === USER_ROLE.ORG_USER || value === USER_ROLE.REVIEWER || value === USER_ROLE.VIEWER) {
    //   dispatch(setActiveDashboardTab(DASHBOARD_TABS.ALL_OPPORTUNITIES));
    //   navigate(RouteConstants.DASHBOARD);
    // } else {
    //   dispatch(setActiveDashboardTab(DASHBOARD_TABS.OVERVIEW));
    //   navigate(RouteConstants.HOME);
    // }

          // dispatch(setActiveDashboardTab(DASHBOARD_TABS.OVERVIEW));
      navigate(RouteConstants.LANDING_PAGE);
    dispatch(setCurrentRole(value));
    setUserRole(value);
    tagEvent(TAG_EVENT_CONST.role, { UserRole: value });
  }

  
  //Manage Profile functionality 
  // const onManageProfileClick = () => {
  //   if(!isManageProfileDiabled)
  //   {
  //     history.push(RouteConstants.MANAGE_PROFILE); 
  //     setShowProfilePopup(false);
  //   }
  // }

  //Temp code to fetch image.
  //TODO - Move the image fetch functionality to backend

  const onLogoClickHandle = () => {
    // if (currentRole === USER_ROLE.REVIEWER) {
    //   navigate(RouteConstants.DASHBOARD);
    // }
    // else {
    //   navigate(RouteConstants.HOME);
    // }
    navigate(RouteConstants.LANDING_PAGE);//navigation to the dashboard page changed to landing page.


    
  }

  let src;
  try {
    src = require(`../../images/profile/${eid.toLowerCase()}.jpg`);
  }
  catch (err) {
    src = undefined;
  }

  const handleLogout = () => {
    isAks() ? props.keycloak.logout() : userManager.signoutRedirect();
  }

  const navigateToControlCenter = () => {
    let hostName = window.location.hostname;
    if (hostName.includes('cam.hia')) {
      window.open("https://rbac.hia.honeywell.com", '_blank', 'noopener,noreferrer');
    } else if (hostName.includes('-dev')) {
      window.open("https://rbac-dev.hia.honeywell.com", '_blank', 'noopener,noreferrer');
    } else if (hostName.includes('-qa')) {
      window.open("https://rbac-qa.hia.honeywell.com", '_blank', 'noopener,noreferrer');
    }
  }

  const isAdminCheck = () => {
    return adminUser(userOnboardData && userOnboardData.roles)
  }
  const handleEnableGuidetour = () => {
    // code to enable guide tour in the application will come here
     setIsOpen(true);
     dispatch(setGuideTour(true));

    //  sessionStorage.setItem("guideTour", "true") ;



  }
  const roles = [ 'insight.owner', 'insight.org_user', 'insight.power_user', 'insight.domain_focal', 'insight.functional_leadership', 'model.labeler', 'model.power_user', 'model.functional_leadership', 'insight.viewer' ]; 
  const shouldShowImage = roles.includes(currentRole) && 
  location.pathname !== "/landing_page1";



  // if(history.pathname === RouteConstants.LANDING_PAGE) return null
  return (
    <div className="fi-header">
      <Header menu={props.menu} title={smallDevice ? '' : headerTitle} isForge={false} logoUrl={forgeLogo} responsive={false} className='fi-header-title' onMenuToggle={props.toggleSideBar} onLogoClick={onLogoClickHandle}>
      </Header>
      {eid &&
        <div className='fi-header__items'>
          {isAdminCheck() && <ActiveUserList />}
          {/* <span>{userOnboardData && userOnboardData.roles && userOnboardData.roles?.length > 1 && userOnboardData.roles?.find((value) => { return value === USER_ROLE.ORG_USER || value === USER_ROLE.REVIEWER || value === USER_ROLE.VIEWER||value === USER_ROLE.MODEL_POWER_USER })
          && <Select className='custom-select role-switch'
            placeholder={userRoles?.length > 0 ? userRoles[0].text : ''}
            options={userRoles}
            value={currentRole}
            onChange={roleSwitchHandle} />}
          </span> */}         
           {/* {(currentRole==='insight.owner' || currentRole==='insight.org_user'|| currentRole==='insight.power_user'|| currentRole==='insight.domain_focal'|| currentRole==='insight.functional_leadership' || currentRole=== 'model.labeler' || currentRole==='model.power_user'||currentRole==='model.functional_leadership'|| currentRole==='insight.viewer')&&
        <img src={TourIcon} className='training-help' name="badge-help" title='CAMS Guide Tour'
        onClick={handleEnableGuidetour} /> } */}
        
        {shouldShowImage&&
        <img src={TourIcon} className='training-help' name="badge-help" title='CAMS Guide Tour'
        onClick={handleEnableGuidetour} /> }

{/* {(currentRole === 'insight.owner' || currentRole === 'insight.org_user' || currentRole === 'insight.power_user' || currentRole === 'insight.domain_focal' || currentRole === 'insight.functional_leadership' || currentRole === 'model.labeler' || currentRole === 'model.power_user' || currentRole === 'model.functional_leadership' || currentRole === "insight.viewer") &&
            <img src="https://www.svgrepo.com/show/134319/presentation.svg" className='training-help' name="badge-help" title='CAMS Training'
             onClick={handleEnableGuidetour} /> } */}



          <HeaderDropdown />
          {isAks() ? <RequestNewAlert /> : <></>}
          <a href="https://honeywell.service-now.com/itdirect?id=fix_something&sys_id=6896b436dbfdcf8092773220ad961954" target="_blank" title='Contact CAMS Support'>
            <img src={CallIcon} alt="Call" className='contact-support' />
          </a>
          <Flag closeAllOtherPopup={() => closeAllOtherPopup()} />
          {showFeedbackPopup ? <Popup
            open={showFeedbackPopup}
            className="feedback-block"
            element={<></>}
            position="left center"
          >
            <div onClick={handleClickInsideFeeback}
              ref={feedbackref}
              className="feedback-popup-container"
            >
              <CSSTransition
                in={showFeedbackPopup}
                timeout={300} appear
                classNames="ct-feedback-popup"
                unmountOnExit={true}
              >
                <FeedbackCard onClose={closeFeedbackPopup}
                />
              </CSSTransition>
            </div>
          </Popup> : null}
          <Popup open={showProfilePopup} offset="0, 0" className="profile-popup" onClick={handleClickInside}
            element={
              isAks() ? <>
                <div onClick={() => {
                  setShowProfilePopup(false);
                  setFeedbackPopup(false);
                  setShowProfileMenuPopup(true);
                }}
                  data-testid="showProfilePopup" className={`fi-header__items__anytime-feedback ${showProfilePopup ? 'fi-header__items__anytime-feedback--selected' : ''}`}>
                  <Icon root="common" name="user" size="medium" />
                </div>
              </> :
                <div onClick={() => {
                  setShowProfilePopup(false); 
                  setFeedbackPopup(false); 
                  setShowProfileMenuPopup(true);
                }
                } data-testid="showProfilePopup" className={`fi-header__items__user-profile ${showProfilePopup ? 'fi-header__items__user-profile--selected' : ''}`}>
                  {src ?
                    <img src={require(`../../images/profile/${eid.toLowerCase()}.jpg`).default} alt={IMAGE_NOT_FOUND} /> :
                    <img src={user_img_url} alt={IMAGE_NOT_FOUND} />
                  }
                </div>
            }
            position="bottom right" >
          </Popup>

          {showProfileMenuPopup ?
            <div
              ref={profileref}
            >
              <VerticalMenu width={400} className='feedback-menu'>
                <VerticalMenu.Item>
                  <div className="user-details__user-name">
                    {name ? name : ''}
                  </div>
                  <div className="user-details__user-id">
                    {eid ? eid.toUpperCase() : ''}
                  </div></VerticalMenu.Item>
                <VerticalMenu.Item disabled>{manageProfile}</VerticalMenu.Item>
                {isAks() ? null : <VerticalMenu.Item onClick={() => {
                  navigateToControlCenter()
                }}>{controlCenter}</VerticalMenu.Item>}
                <VerticalMenu.Item onClick={() => { setFeedbackPopup(true); setShowProfileMenuPopup(false); setShowProfilePopup(false); }}>{help}</VerticalMenu.Item>
                <VerticalMenu.Item onClick={() => handleLogout()}>
                  <FontIcon
                    label='sign out'
                    iconPosition = 'left'
                    contentProps={<span>{signOut}</span>}
                    iconSize = 'medium'
                    iconName='fa fa-door-open'>{signOut}</FontIcon>
                </VerticalMenu.Item>
              </VerticalMenu>
            </div> : null}
        </div>
      }
    </div>
  )
}

export default AppHeader;
